<template>
  <div class="parkingdescribe">
    <div class="header">
      <div class="title">智能停车系统描述</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="left">
        <img :src="parkingdescribeLogo" alt="" />
      </div>
      <div class="right">
        <div class="title">基本功能</div>
        <div class="text">
          “智能找车位+自动缴停车费”，服务于车主的日常停车、错时停车、车位租赁、汽车后市场服务、反向寻车、停车位导航。
        </div>
        <div class="item-title">优势</div>
        <div class="list">
          <div class="item" v-for="item in list" :key="item.id">
            <img :src="item.logo" alt="" />
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import parkingdescribeLogo from "../../../../assets/programme/parkingdescribeLogo.png";
import yesLogo from "../../../../assets/programme/yesLogo.png";

export default {
  setup() {
    return reactive({
      parkingdescribeLogo: parkingdescribeLogo,
      list: [
        {
          id: 1,
          title: "快速通行",
          logo: yesLogo,
        },
        {
          id: 2,
          title: "提供特殊车位",
          logo: yesLogo,
        },
        {
          id: 3,
          title: "同样空间内停入更多的车",
          logo: yesLogo,
        },
      ],
    });
  },
};
</script>

<style scoped>
.parkingdescribe {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.body .left img {
  width: 583px;
}
.body .right {
  width: 500px;
}
.body .right .title {
  font-size: 16px;
  color: #333;
}
.body .right .text {
  font-size: 14px;
  color: #3d3d3d;
  margin-top: 20px;
}
.body .right .item-title {
  font-size: 16px;
  color: #333;
  margin-top: 40px;
}
.body .right .list {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.body .right .list .item {
  display: flex;
  align-items: center;
}
.body .right .list .item img {
  width: 18px;
  margin-right: 10px;
}
.body .right .list .item div {
  color: #2a3d50;
  font-size: 14px;
}
</style>
